/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Transfer_File_SuccessInputs */



/**
* | output |
* | --- |
* | "File transferred successfully!" |
*
* @param {Spaces_Transfer_File_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_transfer_file_success = /** @type {((inputs?: Spaces_Transfer_File_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Transfer_File_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei erfolgreich übertragen!")
	return /** @type {LocalizedString} */ ("File transferred successfully!")
});